function createAgeGateCookie() {
  const cookieName = 'age-gate';
  const cookieValue = JSON.stringify({
    data: '1996',
    country: 'us',
    language: 'en',
    availableLanguages: ['en'],
    pass: true,
  });

  // Set the cookie expiration date to 1 year from now
  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);

  // Create the cookie string
  const cookieString = `${cookieName}=${encodeURIComponent(cookieValue)}; expires=${expiryDate.toUTCString()}; path=/`;

  // Set the cookie
  document.cookie = cookieString;
}

function getTrustFromURL() {
  // Get the current URL
  const url = new URL(window.location.href);

  // Use URLSearchParams to get the value of the 'trust' parameter
  const trust = url.searchParams.get('trust');

  // Log the value or return it
  console.log(trust);
  return trust;
}

function allowOneTimeView() {
  //Used for viewing Privacy, etc. before agte gate is passed.
  // Get the current URL
  //add ?view=true to url
  const url = new URL(window.location.href);
  const canView = url.searchParams.get('view');
  return canView;
}

function hideAgeGate() {
  // Create a <style> element
  var style = document.createElement('style');

  // Add CSS rules to the style element
  var css = 'body { overflow: auto !important; } .age-gate { display: none !important; }';
  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  // Append the <style> element to the end of the body
  document.body.appendChild(style);
}

function redirectIftrusted() {
  if (getTrustFromURL()) { createAgeGateCookie() }
  if (allowOneTimeView()) { hideAgeGate(); }
}



export default redirectIftrusted